import { render } from "./tw-main.vue?vue&type=template&id=78230199"
import script from "./tw-main.vue?vue&type=script&lang=js"
export * from "./tw-main.vue?vue&type=script&lang=js"
script.render = render

export default script